import { Modal, ModalProps } from 'antd'
import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import { useState } from 'react'
import { Cron } from 'react-js-cron'

import 'react-js-cron/dist/styles.css'
import { useLocales } from 'src/locales'

import { normalizeCron } from './cronUtils'

import 'dayjs/locale/ru'
import 'dayjs/locale/ro'
dayjs.extend(localeData)

type Props = {
  value: string
  onCancel: () => void
  onSave: (value: string) => void
} & ModalProps

export const setDayjsLocale = (lang: string) => {
  dayjs.locale(lang)
}

export const CronModal = ({ value, onCancel, onSave }: Props) => {
  const [cron, setCron] = useState(normalizeCron(value) || '10 10 * * 1,2,5')

  const { t, currentLang } = useLocales()
  setDayjsLocale(currentLang?.value)

  const locale = dayjs.localeData()

  return (
    <Modal
      open
      maskClosable={false}
      width={900}
      title={t('cron.schedule')}
      onCancel={onCancel}
      onOk={() => onSave(cron)}
    >
      <Cron
        value={cron}
        setValue={setCron}
        humanizeLabels
        defaultPeriod="month"
        locale={{
          everyText: t('cron.every_text'),
          emptyMonths: t('cron.empty_months'),
          emptyMonthDays: t('cron.empty_month_days'),
          emptyMonthDaysShort: t('cron.empty_month_days_short'),
          emptyWeekDays: t('cron.empty_week_days'),
          emptyWeekDaysShort: t('cron.empty_week_days_short'),
          emptyHours: t('cron.empty_hours'),
          emptyMinutes: t('cron.empty_minutes'),
          emptyMinutesForHourPeriod: t('cron.empty_minutes_for_hour_period'),
          yearOption: t('cron.year_option'),
          monthOption: t('cron.month_option'),
          weekOption: t('cron.week_option'),
          dayOption: t('cron.day_option'),
          hourOption: t('cron.hour_option'),
          minuteOption: t('cron.minute_option'),
          rebootOption: t('cron.reboot_option'),
          prefixPeriod: t('cron.prefix_period'),
          prefixMonths: t('cron.prefix_months'),
          prefixMonthDays: t('cron.prefix_month_days'),
          prefixWeekDays: t('cron.prefix_week_days'),
          prefixWeekDaysForMonthAndYearPeriod: t(
            'cron.prefix_week_days_for_month_and_year_period'
          ),
          prefixHours: t('cron.prefix_hours'),
          prefixMinutes: t('cron.prefix_minutes'),
          prefixMinutesForHourPeriod: t('cron.prefix_minutes_for_hour_period'),
          suffixMinutesForHourPeriod: t('cron.suffix_minutes_for_hour_period'),
          errorInvalidCron: t('cron.error_invalid_cron'),
          clearButtonText: t('cron.clear_button_text'),
          weekDays: locale.weekdays(),
          months: locale.months(),
          altMonths: locale.monthsShort(),
          altWeekDays: locale.weekdaysShort()
        }}
      />
    </Modal>
  )
}
